// firebaseConfig.js

import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth' // Для работы с авторизацией
// Import the functions you need from the SDKs you need

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyALuEG5DqIxKjbEa7vhi0nJ5JE6135EA7A",
  authDomain: "calc5v4.firebaseapp.com",
  projectId: "calc5v4",
  storageBucket: "calc5v4.firebasestorage.app",
  messagingSenderId: "600444094821",
  appId: "1:600444094821:web:f074d86a957a715040798c"
};

// Initialize Firebase

// Экспортируем auth для работы с авторизацией
const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const googleProvider = new GoogleAuthProvider()

export default app
